import React, { useState, useEffect } from "react";

// Package import

import {
  Box,
  Typography,
  Grid,
  Menu,
  MenuItem,
  Fade,
  Paper,
  useTheme,
  TextField,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  Divider,
  Alert,
  Pagination,
  Backdrop,
  Snackbar,
  CircularProgress,
} from "@mui/material";
import { Search as SearchIcon } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { format } from "date-fns";
import { outlinedInputClasses } from "@mui/material/OutlinedInput";

// User Import

import { RoutesUrls } from "../../../Services/Routes/APP";
import { getPagination } from "../../../common/functions";
import { headersPost } from "../../../Services/API";
import { ADMIN_API_ULRS } from "../../../Services/Routes/API";

// Constants

const headings = [
  "Batch #",
  "Total Quantity",
  "Available Quantity",
  "Issued Date",
  "Country",
  "Actions",
];

const rows = [
  {
    Batch: "136315",
    Total_Quantity: " 127785",
    Available_Quantity: "13361",
    Issued_Date: "1-12-2021",
    Country: "Australia",
  },
  {
    Batch: "136315",
    Total_Quantity: " 127785",
    Available_Quantity: "13361",
    Issued_Date: "1-12-2021",
    Country: "Australia",
  },
  {
    Batch: "136315",
    Total_Quantity: " 127785",
    Available_Quantity: "13361",
    Issued_Date: "1-12-2021",
    Country: "Australia",
  },
  {
    Batch: "136315",
    Total_Quantity: " 127785",
    Available_Quantity: "13361",
    Issued_Date: "1-12-2021",
    Country: "Australia",
  },
  {
    Batch: "136315",
    Total_Quantity: " 127785",
    Available_Quantity: "13361",
    Issued_Date: "1-12-2021",
    Country: "Australia",
  },
  {
    Batch: "136315",
    Total_Quantity: " 127785",
    Available_Quantity: "13361",
    Issued_Date: "1-12-2021",
    Country: "Australia",
  },
  {
    Batch: "136315",
    Total_Quantity: " 127785",
    Available_Quantity: "13361",
    Issued_Date: "1-12-2021",
    Country: "Australia",
  },
  {
    Batch: "136315",
    Total_Quantity: " 127785",
    Available_Quantity: "13361",
    Issued_Date: "1-12-2021",
    Country: "Australia",
  },
  {
    Batch: "136315",
    Total_Quantity: " 127785",
    Available_Quantity: "13361",
    Issued_Date: "1-12-2021",
    Country: "Australia",
  },
  {
    Batch: "136315",
    Total_Quantity: " 127785",
    Available_Quantity: "13361",
    Issued_Date: "1-12-2021",
    Country: "Australia",
  },
  {
    Batch: "136315",
    Total_Quantity: " 127785",
    Available_Quantity: "13361",
    Issued_Date: "1-12-2021",
    Country: "Australia",
  },
];

const Batch = () => {
  // Hooks

  const theme = useTheme();
  const navigate = useNavigate();

  //states

  const [anchorEl, setAnchorEl] = useState(null);
  const [totalCount, setTotalCount] = useState(0);
  const [open, setOpen] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [alertIcon, setAlertIcon] = useState("error");
  const [batches, setBatches] = useState([]);
  const [api, setApi] = useState(false);
  const [page, setPage] = useState(1);

  // Constants

  const openMenu = Boolean(anchorEl);

  //menu open handler

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  //menu close handler

  const menuCloseHandler = () => {
    setAnchorEl(null);
  };

  //close alert

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlertOpen(false);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setApi(true);
  };

  //batches

  const getBatches = () => {
    const data = {
      page: page,
    };
    setOpen(true);

    headersPost(ADMIN_API_ULRS.GET_ALL_BATCHES, data)
      .then((res) => {
        setOpen(false);
        if (res?.status === 200 && res?.data?.success) {
          setBatches(res?.data?.batches);
          setTotalCount(res?.data?.total_count);
        } else {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("warning");
        }
      })
      .catch((err) => {
        setOpen(false);
        const { response } = err;
        if (response?.status === 401) {
          localStorage.clear();
          navigate(RoutesUrls?.root);
        } else {
          setAlertOpen(true);
          setAlertMsg(response?.statusText);
          setAlertIcon("error");
        }
      });
  };

  //life cycle

  useEffect(() => {
    getBatches();
  }, [api]);

  //render

  return (
    <>
      <Paper elevation={1} sx={{ borderRadius: 3 }}>
        <Box padding={2}>
          <Box
            display={{ md: "flex", sm: "flex" }}
            justifyContent={{ md: "space-between", sm: "space-between" }}
          >
            <Grid container>
              <Grid item sx={{ p: 1 }}>
                <Typography variant="h5" m={0.5}>
                  Inventory{" "}
                </Typography>
                <Typography component={"span"} m={0.5} color="text.secondary">
                  Updated 30 minutes before
                </Typography>
              </Grid>
            </Grid>
            <Box display={{ xs: "flex" }} justifyContent={{ xs: "right" }}>
              <Box
                display={{ xs: "flex" }}
                justifyContent={{ xs: "right" }}
                mb={2}
              >
                <Button
                  color="primary"
                  variant="contained"
                  size="large"
                  id="fade-button"
                  aria-controls="fade-menu"
                  aria-haspopup="true"
                  aria-expanded={openMenu ? "true" : undefined}
                  onClick={handleClick}
                  sx={{
                    borderRadius: 8,
                    maxHeight: 40,
                    minWidth: 150,
                  }}
                >
                  Actions
                </Button>
                {/* Dropdown */}
                <Menu
                  id="fade-menu"
                  MenuListProps={{
                    "aria-labelledby": "fade-button",
                  }}
                  anchorEl={anchorEl}
                  open={openMenu}
                  onClose={menuCloseHandler}
                  TransitionComponent={Fade}
                >
                  <MenuItem
                    sx={{
                      paddingX: 4,
                    }}
                    onClick={menuCloseHandler}
                  >
                    Units Used
                  </MenuItem>
                  <Divider />
                  <MenuItem
                    sx={{
                      paddingX: 4,
                    }}
                    onClick={menuCloseHandler}
                  >
                    Isued Batch
                  </MenuItem>
                </Menu>
              </Box>
            </Box>
            {/* Table */}
          </Box>
          <Box display={"flex"} justifyContent={"flex-end"}>
            <TextField
              size="small"
              placeholder="Search"
              InputProps={{
                endAdornment: (
                  <SearchIcon
                    sx={{
                      color: theme.palette.primary.dark,
                    }}
                  />
                ),
              }}
              sx={{
                borderRadius: 25,
                backgroundColor: theme.palette.secondary.dark,
                [`.${outlinedInputClasses.root}`]: {
                  borderRadius: 25,
                  paddingX: 2,
                },
              }}
            ></TextField>
          </Box>
          <TableContainer>
            <Table sx={{ marginTop: 5 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  {headings?.map((h, index) => (
                    <TableCell
                      sx={{
                        fontWeight: "bold",
                      }}
                      align="center"
                      key={`${index}-table-heading-${h}`}
                    >
                      {h}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {batches?.map((row, index) => (
                  <TableRow key={`${index}-row.name-${index + 21}`}>
                    <TableCell align="center">
                      {row?.reference_number}
                    </TableCell>
                    <TableCell align="center">{row?.size}</TableCell>
                    <TableCell align="center">
                      {row?.available_quantity}
                    </TableCell>
                    <TableCell align="center">
                      {row?.modifier_date
                        ? format(new Date(row?.modifier_date), "MM/dd/yyyy")
                        : ""}
                    </TableCell>
                    <TableCell align="center">{row?.country}</TableCell>
                    <TableCell align="center">
                      <Button
                        color="secondary"
                        variant="contained"
                        size="small"
                        // onClick={addHandler2}
                        sx={{
                          borderRadius: 4,
                        }}
                      >
                        Details
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <Box paddingTop={4} display={"flex"} justifyContent={"center"}>
              <Pagination
                count={totalCount > 10 ? getPagination(totalCount) : 1}
                page={page}
                onChange={handleChangePage}
                color="primary"
              />
            </Box>
          </TableContainer>
        </Box>
      </Paper>
      <Backdrop
        sx={{
          zIndex: theme.zIndex.drawer + 1,
          color: theme.palette.primary.main,
        }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={alertOpen}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={alertIcon}>
          {alertMsg}
        </Alert>
      </Snackbar>
    </>
  );
};

export default Batch;
